import { z } from 'zod';

// Base schema used in edit mode where email cannot be changed, so it's optional.
// Create mode extends this to require email + password.
export const userFormValidationSchema = z.object({
  first_name: z.string().min(1, 'First name is required'),
  last_name: z.string().min(1, 'Last name is required'),
  email: z.string().email('Email is invalid').optional(),
});
export const userDetailSchema = z.object({
  first_name: z.string().min(1, 'First name is required'),
  last_name: z.string().min(1, 'Last name is required'),
  email: z
    .string()
    .email('Please enter a valid email address')
    .min(1, 'Email is required'),
  cell_phone: z.string().optional(),
});

export const createUserFormValidationSchema = userFormValidationSchema
  .extend({
    email: z.string().email('Email is invalid').min(1, 'Email is required'),
    password: z.string().min(8, 'Password must be at least 8 characters'),
    confirm_password: z.string().min(1, 'Confirm password is required'),
  })
  .refine((data) => data.password === data.confirm_password, {
    message: 'Passwords must match',
    path: ['confirm_password'],
  });
